import React from 'react'

import { observer } from 'mobx-react'

import FilterHandleButton from '~/client/src/shared/components/Filters/components/FilterHandleButton/FilterHandleButton'

interface IProps {
  isActive: boolean
  isHidden?: boolean
  toggleShowingOfCDOrders(): void
}

const concreteDirect = 'Concrete Direct'

const ConcreteDirectFilterButton: React.FC<IProps> = observer(
  ({ isActive, isHidden, toggleShowingOfCDOrders }) => {
    if (isHidden) {
      return null
    }

    return (
      <FilterHandleButton onClick={toggleShowingOfCDOrders} isActive={isActive}>
        <span>{concreteDirect}</span>
      </FilterHandleButton>
    )
  },
)

export default ConcreteDirectFilterButton
